import type { ProgressReport } from '@brighterly/lib-core-types/progress-report/interfaces'
import type { ProgressReportStore } from './interfaces'
import type { ScopeStatus } from '@shared/lib/scope'

import { useDisciplineStore } from '@entities/customer/@x/progress-report'
import { entryData, entryRevalidating, entryStatus } from '@shared/lib/scope'

import { report } from '../../lib/report'
import { period } from '../../lib/period'
import { tutor } from '../../lib/tutor'
import { message } from '../../lib/message'
import { stats } from '../../lib/stats'
import { lessons } from '../../lib/lessons'
import { achievements } from '../../lib/achievements'
import { schedule } from '../../lib/schedule'

const getActiveId = (): number | null => useDisciplineStore().activeDiscipline?.id ?? null

export const getters = {
  isLoading: (state: ProgressReportStore): boolean => {
    const id = getActiveId()
    return entryStatus(state.reportById, id) === 'loading' || entryStatus(state.listById, id) === 'loading'
  },
  isReportLoading: (state: ProgressReportStore): boolean => entryStatus(state.reportById, getActiveId()) === 'loading',
  isReportsLoading: (state: ProgressReportStore): boolean => entryStatus(state.listById, getActiveId()) === 'loading',
  getListStatus: (state: ProgressReportStore) => (id: number | null): ScopeStatus => entryStatus(state.listById, id),
  isListRevalidating: (state: ProgressReportStore) => (id: number | null): boolean => entryRevalidating(state.listById, id),
  getReportStatus: (state: ProgressReportStore) => (id: number | null): ScopeStatus => entryStatus(state.reportById, id),
  getReportById: (state: ProgressReportStore) => (id: number | null): ProgressReport | null => entryData(state.reportById, id),
  getReports: (state: ProgressReportStore): ProgressReport[] | null => entryData(state.listById, getActiveId()),
  isNewProgressReport: (state: ProgressReportStore): boolean => {
    const id = getActiveId()
    return id === null ? false : !!state.newById[id]
  },
  ...report,
  ...period,
  ...tutor,
  ...message,
  ...stats,
  ...lessons,
  ...achievements,
  ...schedule,
}
